export const MIN_ISLAND_MEMBERS = 1;
export const UNTAGGED_KEY = '__none__';
/** Extra pack radius so a nebula title can sit on the rim without kissing a neighbour. */
export const CLUSTER_TITLE_BAND = 0.62;
/** Bump when packing / island spacing changes so the graph cache recomputes. */
export const LAYOUT_REVISION = 12;

/** Coarse window shape so a resize does not reflow every pixel. */
export function quantizeLayoutAspect(aspect) {
  const a = Number.isFinite(aspect) && aspect > 0 ? aspect : 1.6;
  return Math.round(Math.min(2.4, Math.max(0.55, a)) * 6) / 6;
}

export function mulberry32(seed) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
